import {deleteRequest, get, post, put} from "services/BaseClient/Client"
import endPoints from "./EndPoints"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";




export const getSavedSearches = async (): Promise<DataResponse<any>> => {
    const url = `${endPoints.getSavedSearchs}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
  export const addSavedSearch = async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.addSavedSearch}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data, config);
  };

  export const updateSavedSearch= async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.updateSavedSearch}`;
    const config = headers.content_type.application_json;
    return put<DataResponse<any>>(url, data, config);
  };

  export const deleteSavedSearch= async (data: any): Promise<DataResponse<any>> => {
    const url = `${endPoints.deleteSavedSearch}/${data.id}`;
    const config = headers.content_type.application_json;
    return deleteRequest<DataResponse<any>>(url, data, config);
  };